<style lang="scss" scoped>
@function rem($v) {
  @return $v / 100 + rem;
}

.load_mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.load_box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  width: 125px;
  height: 125px;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-flow: column nowrap;
  justify-content: space-between;
  &:before,
  &:after {
    content: '';
    display: block;
  }
  > img {
    width: 50px;
    height: 50px;
  }

  .load_title {
    color: #fff;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<template>

  <transition name="fade">
    <div class="load" v-show="show">
      <div class="load_mask" v-show="mask"></div>
      <div class="load_box">
        <img src='../../assets/images/loading.gif' />
        <div class="load_title">{{text}}</div>
      </div>
    </div>
  </transition>

</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    open: {
      type: Function,
      default() {},
    },
    mask: {
      type: Boolean,
      default: true,
    },
  },
  name: 'Loading',
  data() {
    return {
      show: false,
    }
  },
  methods: {},
}
</script>


// WEBPACK FOOTER //
// src/components/loading/index.vue